module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABFUlEQVQ4jY2T4U0DMQyFv6D+Pand4Ea4blAmACagnaDdAJjgYAM2YITCBO0GdAOQbwAjVwkYXyrdk6zkfLHznmNToKpVE9gLfAp8CazKmYJZ2QwpdcAtfzgC30ALLPPaA+/UIPAmoM7ONxqDcqvfjxg0qneBxdGx2126+Sp8r4CHbPfO3wd59QSN6jOwAJ6Aj6rWgFnFNwe2wMnLuIQowVicGtVFo7qcwmCUIKCN7IaU5pMSDCmtc/FenNtk7X2SaoJ8wIKvc00MN8Am12U9CvJt7BsoNNejQGv/ptYgwlq72Bm1ZzQYzW5IyYpotK2pTP9rpj/ukTiJAr3AwSg73y7PyL+XqCbIAabZAiyRrTba3e8wAT+eirWFc1ZA6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_temperature.png
// module id = aF/J
// module chunks = 4